import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        isOpen: Boolean
    };
    static targets = [
        "button",
        "container",
        "clearButton",
        "noResults"
    ];

    connect() {
        if (this.hasButtonTarget) {
            this.icon = this.buttonTarget.querySelector('svg');
            this.buttonTarget.addEventListener('click', this.handleToggle.bind(this));
        }
        this.initializeItems();
        
        if (this.isOpenValue) {
            this.open();
        }
        
        if (this.hasClearButtonTarget) {
            const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', this.updateClearButtonVisibility.bind(this));
                
                if (checkbox.checked) {
                    this.clearButtonTarget.classList.remove('hidden');
                }
            });
        }
    }

    updateClearButtonVisibility() {
        if (!this.hasClearButtonTarget) return;
        
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        const hasCheckedBoxes = Array.from(checkboxes).some(checkbox => checkbox.checked);
        
        if (hasCheckedBoxes) {
            this.clearButtonTarget.classList.remove('hidden');
        } else {
            this.clearButtonTarget.classList.add('hidden');
        }
    }

    clearAll() {
        const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        
        const event = new Event('change', { bubbles: true });
        if (checkboxes.length > 0) {
            checkboxes[0].dispatchEvent(event);
        }
        
        if (this.hasClearButtonTarget) {
            this.clearButtonTarget.classList.add('hidden');
        }

        this.clear()
    }

    initializeItems() {
        const items = this.containerTarget.querySelectorAll('.flex.items-center.mb-2');
        items.forEach((item, index) => {
            if (index >= 5) {
                item.classList.add('hidden', 'extra-item');
            }
        });
        this.containerTarget.style.display = 'block';
        if (this.hasNoResultsTarget) {
            this.noResultsTarget.classList.add('hidden');
        }
        if (this.hasButtonTarget && items.length <= 5) {
            this.buttonTarget.style.display = 'none';
        }
    }

    handleToggle() {
        const isExpanded = this.buttonTarget.getAttribute('aria-expanded') === 'true';
        (isExpanded) ? this.close() : this.open();
    }

    open() {
        const extraItems = this.containerTarget.querySelectorAll('.extra-item');
        extraItems.forEach(item => item.classList.remove('hidden'));
        this.buttonTarget.setAttribute('aria-expanded', true);
        this.icon.classList.add('rotate-180');
        this.buttonTarget.querySelector('span').textContent = 'Show Less';
    }

    close() {
        const extraItems = this.containerTarget.querySelectorAll('.extra-item');
        extraItems.forEach(item => item.classList.add('hidden'));
        this.buttonTarget.setAttribute('aria-expanded', false);
        this.icon.classList.remove('rotate-180');
        this.buttonTarget.querySelector('span').textContent = 'See All';
    }

    search(event) {
        const searchTerm = event.target.value.toLowerCase();
        const items = this.element.querySelectorAll('input[name="pillar"]');
        let hasAnyMatch = false;

        if (searchTerm) {
            if (this.hasButtonTarget) {
                this.buttonTarget.classList.add("hidden");
            }
            items.forEach(item => {
                const label = item.getAttribute('data-label').toLowerCase();
                if (label.includes(searchTerm)) {
                    item.parentElement.classList.remove('hidden');
                    hasAnyMatch = true;
                } else {
                    item.parentElement.classList.add('hidden');
                }
            });

            this.containerTarget.classList.toggle('hidden', !hasAnyMatch);

            if (this.hasNoResultsTarget) {
                this.noResultsTarget.classList.toggle('hidden', hasAnyMatch);
            }
        } else {
            if (this.hasButtonTarget) {
                this.buttonTarget.classList.remove("hidden");
            }
            this.clear()
        }
    }

    clear() {
        document.getElementById("searchPillars").value='';
        const items = this.element.querySelectorAll('input[name="pillar"]');
        items.forEach(item => { 
            item.parentElement.classList.remove('hidden');
        });
        this.containerTarget.classList.remove('hidden');
        if (this.hasNoResultsTarget) {
            this.noResultsTarget.classList.add('hidden');
        }
        if (this.hasButtonTarget) {
            const span = this.buttonTarget.querySelector("span");
            if(span.textContent.trim().toUpperCase() === "SHOW LESS"){
                this.close();
            }
            this.buttonTarget.classList.remove("hidden");
        }
        this.initializeItems();
    }
}